import React, { useState } from 'react';

// Shared brand logo for auth pages. Serves /logo.png from public/.
// Falls back to the original "S" mark if the image is missing so a
// missing asset never breaks the login screen.
const BrandLogo = ({ className = '' }) => {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return (
      <div
        className={`inline-flex items-center justify-center h-12 w-12 rounded-lg bg-blue-600 ${className}`}
      >
        <span className="text-white font-semibold text-lg">S</span>
      </div>
    );
  }

  // Source asset is a wide 1600x896 wordmark+tagline. object-contain inside
  // a fixed square keeps it small and undistorted on the compact auth header.
  return (
    <img
      src="/logo.png"
      alt="mySMS360"
      onError={() => setFailed(true)}
      className={`h-16 w-auto max-w-[180px] object-contain mx-auto ${className}`}
    />
  );
};

export default BrandLogo;
